@if (item) {
  <div class="last-event">
    <div class="last-event__last">
      <span class="last-event__last--header">Last event</span>
      @if (item.events.lastEvent.name) {
        <span class="last-event__last--status">{{ item.events.lastEvent.name }}</span>
        @if (item.events.lastEvent.location) {
          <span class="last-event__last--location">{{ item.events.lastEvent.location.name }}</span>
        }
        @if (item.events.lastEvent.timeUtc || item.events.lastEvent.timeLocal) {
          <span class="last-event__last--date">
            {{ item.events.lastEvent.timeLocal || item.events.lastEvent.timeUtc | date: dateTimeFormat }}
          </span>
        }
        @if (item.events.lastEvent.containerNo) {
          <span class="last-event__last--container">({{ item.events.lastEvent.containerNo }})</span>
        }
      } @else {
        <span class="last-event__last--no-event">No events registered</span>
      }
    </div>
  </div>
} @else {
  <div class="skeleton"></div>
}
